import { removeTypenameFromObject } from 'approot/shared/logic/remove-typename';
import { InteractiveResponseCategoriseItem } from '../../categorise/interactive-response-categorise.constants';
import { InteractiveResponseItem } from './interactive-response.constants';

export function getItemPayload(
  items: (InteractiveResponseItem | InteractiveResponseCategoriseItem)[]
) {
  return items.map(item => {
    const { __typename, image, imageUrls, cropData, ...rest } = item;
    return {
      ...rest,
      cropData: cropData ? removeTypenameFromObject(cropData) : null,
      image: image
        ? {
            description: image.description,
            fileName: image.fileName,
            itemId: image.itemId,
            key: image.key,
            data: image.data ? removeTypenameFromObject(image.data) : null,
          }
        : null,
      audio: item.audio
        ? {
            key: item.audio.key,
            fileName: item.audio.fileName,
          }
        : null,
    };
  });
}
